import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";

interface HtmlVccRendererProps {
  htmlCode: string;
}

const HtmlVccRenderer: React.FC<HtmlVccRendererProps> = ({ htmlCode }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const iframe = document.createElement("iframe");
    iframe.sandbox.add(
      "allow-same-origin",
      "allow-scripts",
      "allow-popups",
      "allow-forms"
    );
    iframe.style.border = "none";
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "100%";
    iframe.style.height = "100%";

    container.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write(htmlCode);
      doc.close();
    }

    return () => {
      container.removeChild(iframe);
    };
  }, [htmlCode]);

  const aspectRatio = (1088.45 / 1725.56) * 100 + 3.5;

  return (
    <Box>
      <div
        data-test-id="vcc-iframe-container"
        style={{
          position: "relative",
          width: "100%",
          paddingBottom: `${aspectRatio}%`,
        }}
      >
        <div
          ref={containerRef}
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
          }}
        />
      </div>
    </Box>
  );
};

export default HtmlVccRenderer;
